import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import {
  buildCanonicalUrl,
  buildWebPageJsonLd,
  organizationJsonLd,
  websiteJsonLd,
} from "@/lib/seo";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import PopularExchangeRates from "@/components/PopularExchangeRates";
import CurrencyConverter from "@/components/CurrencyConverter";
import ForexHomeDeliveryModal from "@/components/ForexHomeDeliveryModal";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import AirlinePartners from "@/components/AirlinePartners";
import PackagesSection from "@/components/PackagesSection";
import TeamSection from "@/components/TeamSection";
import ContactSection from "@/components/ContactSection";
import CareersSection from "@/components/CareersSection";
import Footer from "@/components/Footer";
import { Truck, ShieldCheck, Clock, MapPin, X, Building2, Star } from "lucide-react";

const brochures = [
  {
    title: "Indigo Airlines - Delhi To London",
    imageSrc: "/brochure7.jpg",
  },
  {
    title: "Indigo Airlines - London To Delhi",
    imageSrc: "/brochure8.jpg",
  },
  {
    title: "Oman Air",
    imageSrc: "/brochure1.jpg",
  },
  {
    title: "Oman Air",
    imageSrc: "/brochure2.jpg",
  },
  {
    title: "Oman Air",
    imageSrc: "/brochure3.png",
  },
  {
    title: "Jazeera Airways",
    imageSrc: "/brochure4.png",
  },
  {
    title: "Oman Air",
    imageSrc: "/brochure5.png",
  },
  {
    title: "United Airlines",
    imageSrc: "/brochure6.jpg",
  },
];

const announcementSlides = [
  // {
  //   src: "/rajasthan2.png",
  //   alt: "Rajasthan 2026 travel poster",
  // },
  // {
  //   src: "/andaman.png",
  //   alt: "Andaman 2026 travel poster",
  // },
  // {
  //   src: "/odisha2026.png",
  //   alt: "Odisha 2026 travel poster",
  // },
  // {
  //   src: "/bhutan2026.png",
  //   alt: "Bhutan 2026 travel poster",
  // },
];

export default function Home() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [activeImageSrc, setActiveImageSrc] = useState<string | null>(null);
  const [showAnnouncement, setShowAnnouncement] = useState(true);
  const [announcementIndex, setAnnouncementIndex] = useState(0);
  const [showForexNotification, setShowForexNotification] = useState(true);

  const showAnnouncementPrev = () =>
    setAnnouncementIndex((prev) =>
      prev === 0 ? announcementSlides.length - 1 : prev - 1,
    );

  const showAnnouncementNext = () =>
    setAnnouncementIndex((prev) =>
      prev === announcementSlides.length - 1 ? 0 : prev + 1,
    );

  useEffect(() => {
    if (!showAnnouncement) return;
    const interval = setInterval(showAnnouncementNext, 5000);
    return () => clearInterval(interval);
  }, [showAnnouncement]);

  useEffect(() => {
    if (showAnnouncement) {
      setAnnouncementIndex(0);
    }
  }, [showAnnouncement]);

  const showPrev = () =>
    setActiveIndex((prev) => (prev === 0 ? brochures.length - 1 : prev - 1));
  const showNext = () =>
    setActiveIndex((prev) => (prev === brochures.length - 1 ? 0 : prev + 1));

  const openImage = (src: string) => {
    setActiveImageSrc(src);
    setIsImageOpen(true);
  };

  const closeImage = () => {
    setIsImageOpen(false);
    setActiveImageSrc(null);
  };

  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Travel Wings Global | Currency Exchange & Travel Services"
        description="Trusted forex services, curated travel packages, visa assistance, and insurance with transparent rates across India."
        path="/"
        structuredData={[
          organizationJsonLd,
          websiteJsonLd,
          buildWebPageJsonLd({
            name: "Travel Wings Global | Currency Exchange & Travel Services",
            description:
              "Trusted forex services, curated travel packages, visa assistance, and insurance with transparent rates across India.",
            url: buildCanonicalUrl("/"),
            type: "TravelAgency",
          }),
        ]}
      />
      <Navigation />

      {showForexNotification && (
        <div className="bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm py-2.5 px-4">
          <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
            <div className="flex items-center gap-x-2 gap-y-1 flex-1 justify-center flex-wrap">
              <Star className="w-4 h-4 shrink-0" />
              <span className="font-semibold whitespace-nowrap">New Service:</span>
              <span className="hidden sm:inline">Foreign Currency — Home Delivery or Branch Pickup across Delhi</span>
              <span className="sm:hidden">Forex Home Delivery &amp; Branch Pickup</span>
              <ForexHomeDeliveryModal
                trigger={
                  <button className="underline font-bold hover:text-orange-100 transition whitespace-nowrap ml-1">
                    Order Now
                  </button>
                }
              />
            </div>
            <button
              type="button"
              onClick={() => setShowForexNotification(false)}
              aria-label="Dismiss notification"
              className="shrink-0 hover:opacity-70 transition ml-2"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      <HeroSection />

      {/*{showAnnouncement && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-8"
          role="presentation"
          onClick={() => setShowAnnouncement(false)}
        >
          <div
            className="relative w-full max-w-[1100px] md:max-w-5xl bg-transparent rounded-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="absolute top-2 right-2 sm:top-3 sm:right-3 z-10 inline-flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-full bg-black/40 text-white hover:bg-black/60 transition"
              aria-label="Close New Year announcement"
              onClick={() => setShowAnnouncement(false)}
            >
              ×
            </button>
            <div className="pointer-events-none absolute inset-x-0 bottom-4 flex items-center justify-center gap-4 sm:inset-0 sm:justify-between sm:px-6">
              <button
                type="button"
                className="pointer-events-auto inline-flex h-11 w-11 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-black/40 text-white shadow-lg hover:bg-black/60 transition"
                aria-label="Previous announcement poster"
                onClick={(e) => {
                  e.stopPropagation();
                  showAnnouncementPrev();
                }}
              >
                ‹
              </button>
              <button
                type="button"
                className="pointer-events-auto inline-flex h-11 w-11 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-black/40 text-white shadow-lg hover:bg-black/60 transition"
                aria-label="Next announcement poster"
                onClick={(e) => {
                  e.stopPropagation();
                  showAnnouncementNext();
                }}
              >
                ›
              </button>
            </div>
            <img
              src={announcementSlides[announcementIndex].src}
              alt={announcementSlides[announcementIndex].alt}
              width={1200}
              height={675}
              className="h-full w-full max-h-[90vh] max-w-[92vw] object-contain mx-auto"
            />
          </div>
        </div>
      )}*/}

      {/* Char Dham Yatra Banner */}
      {/* <section className="py-8 md:py-16 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl min-h-[400px] md:min-h-[500px]">
            <div className="absolute inset-0">
              <img
                src="/char-dham-banner.png"
                alt="Char Dham Temples - Kedarnath, Badrinath, Gangotri, Yamunotri"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70 md:bg-gradient-to-r md:from-black/70 md:via-black/50 md:to-black/70"></div>
            </div>

            <div className="relative z-10 p-6 md:p-16 text-white h-full flex items-center">
              <div className="max-w-4xl mx-auto text-center w-full">
                <div className="mb-4 md:mb-6">
                  <span className="text-4xl md:text-6xl">🕉️</span>
                </div>
                <h2 className="text-3xl md:text-6xl font-bold mb-4 md:mb-6">
                  Char Dham Yatra
                </h2>
                <p className="text-lg md:text-2xl mb-6 md:mb-8 text-amber-100 leading-relaxed max-w-3xl mx-auto">
                  Embark on a sacred pilgrimage to the four divine shrines of
                  Uttarakhand - Kedarnath, Badrinath, Gangotri, and Yamunotri.
                </p>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-6 md:mb-8">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-2 md:p-3 border border-white/20">
                    <div className="text-lg md:text-xl mb-1">🏔️</div>
                    <div className="font-semibold text-xs md:text-sm">
                      Kedarnath
                    </div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-2 md:p-3 border border-white/20">
                    <div className="text-lg md:text-xl mb-1">🏛️</div>
                    <div className="font-semibold text-xs md:text-sm">
                      Badrinath
                    </div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-2 md:p-3 border border-white/20">
                    <div className="text-lg md:text-xl mb-1">🌊</div>
                    <div className="font-semibold text-xs md:text-sm">
                      Gangotri
                    </div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-2 md:p-3 border border-white/20">
                    <div className="text-lg md:text-xl mb-1">⛰️</div>
                    <div className="font-semibold text-xs md:text-sm">
                      Yamunotri
                    </div>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
                  <div className="text-center">
                    <div className="text-sm md:text-lg text-amber-200 mb-1 md:mb-2">
                      Starting From
                    </div>
                    <div className="text-3xl md:text-4xl font-bold text-yellow-300">
                      ₹25,999
                    </div>
                  </div>
                  <button className="bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-bold px-6 md:px-8 py-3 rounded-full text-sm md:text-lg transition-all duration-300 shadow-lg">
                    Book Sacred Journey
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Rajasthan Trifold Banner */}
      {/* <section className="py-6 md:py-12 bg-gradient-to-b from-amber-50 via-orange-50 to-amber-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl min-h-[320px] md:min-h-[420px]">
            <div className="absolute inset-0">
              <img
                src="/rajasthan.jpg"
                alt="Rajasthan desert dunes glowing under a warm sunset sky"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/55 to-black/75 md:bg-gradient-to-r md:from-black/80 md:via-black/60 md:to-black/70"></div>
            </div>

            <div className="relative z-10 p-6 md:p-16 text-white h-full flex items-center">
              <div className="max-w-4xl mx-auto text-center w-full">
                <div className="mb-4 md:mb-6">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm text-amber-100 text-sm md:text-base tracking-wide">
                    <span className="text-2xl md:text-3xl">🐪</span>
                    <span className="uppercase">Royal Rajasthan Escape</span>
                  </div>
                </div>
                <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-5">
                  Rajasthan Trifold: Jodhpur • Udaipur • Jaisalmer
                </h2>
                <p className="text-lg md:text-2xl mb-6 md:mb-8 text-amber-100 leading-relaxed max-w-3xl mx-auto">
                  Meander through blue-washed alleys, mirror-still lakes, and
                  golden dunes with curated forts, lakeside palaces, and desert
                  campfire evenings under starry skies.
                </p>

                <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 md:mb-8">
                  <span className="px-4 py-2 rounded-full bg-white/10 border border-white/20 text-xs md:text-sm text-amber-100">
                    Boutique heritage stays
                  </span>
                  <span className="px-4 py-2 rounded-full bg-white/10 border border-white/20 text-xs md:text-sm text-amber-100">
                    Private transfers & curated guides
                  </span>
                  <span className="px-4 py-2 rounded-full bg-white/10 border border-white/20 text-xs md:text-sm text-amber-100">
                    Sunset boat & desert camp evenings
                  </span>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20">
                    <div className="text-2xl md:text-3xl mb-2">🏰</div>
                    <div className="font-semibold text-sm md:text-lg">
                      Jodhpur
                    </div>
                    <p className="text-xs md:text-sm text-amber-100 mt-1">
                      Mehrangarh sunsets, blue lanes, and rooftop thali under
                      lantern light.
                    </p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20">
                    <div className="text-2xl md:text-3xl mb-2">🌊</div>
                    <div className="font-semibold text-sm md:text-lg">
                      Udaipur
                    </div>
                    <p className="text-xs md:text-sm text-amber-100 mt-1">
                      Lake Pichola cruises, palace courtyards, and marble ghats
                      at dusk.
                    </p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20">
                    <div className="text-2xl md:text-3xl mb-2">🏜️</div>
                    <div className="font-semibold text-sm md:text-lg">
                      Jaisalmer
                    </div>
                    <p className="text-xs md:text-sm text-amber-100 mt-1">
                      Thar dune drives, luxury camps, and folk music beneath
                      desert skies.
                    </p>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6">
                  <div className="text-center">
                    <div className="text-sm md:text-base text-amber-200 mb-1 md:mb-2">
                      Flexible dates • Private guides • Handpicked stays
                    </div>
                  </div>
                  <button className="bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 hover:from-amber-600 hover:via-orange-600 hover:to-rose-600 text-white font-bold px-6 md:px-8 py-3 rounded-full text-sm md:text-lg transition-all duration-300 shadow-lg">
                    Start Your Rajasthan Adventure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section
        className="mx-auto my-8 md:my-12 w-full max-w-[786px] cursor-pointer"
        style={{ aspectRatio: "786 / 490" }}
        role="button"
        tabIndex={0}
        aria-label="Open United Airlines brochure"
        onClick={() => setShowPdf(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setShowPdf(true);
          }
        }}
      >
        <img
          src="/unitedairlines.jpg"
          alt="United Airlines aircraft"
          className="w-full h-full object-contain"
        />
      </section>

      {showPdf && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-8 md:py-12"
          onClick={() => setShowPdf(false)}
          role="presentation"
        >
          <div
            className="relative w-full max-w-5xl bg-white rounded-xl shadow-2xl overflow-hidden h-[75vh] md:h-[80vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="absolute top-3 right-3 z-10 inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/70 text-white hover:bg-black/85 transition"
              aria-label="Close United Airlines brochure"
              onClick={() => setShowPdf(false)}
            >
              ×
            </button>
            <iframe
              src="/unitedairlines.pdf"
              title="United Airlines brochure"
              className="w-full h-full"
            />
          </div>
        </div>
      )} */}
      <section className="mx-auto my-10 md:my-14 w-full max-w-6xl px-4">
        <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-500">
              Fresh off the press: travel inspiration to spark your next trip
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
              Explore Our Latest Offerings
            </h2>
          </div>
          {brochures.length > 1 && (
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={showPrev}
                className="h-10 w-10 rounded-full border border-gray-200 bg-white text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500"
                aria-label="Previous brochure"
              >
                ‹
              </button>
              <button
                type="button"
                onClick={showNext}
                className="h-10 w-10 rounded-full border border-gray-200 bg-white text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500"
                aria-label="Next brochure"
              >
                ›
              </button>
            </div>
          )}
        </div>

        {brochures.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-8 text-center text-gray-500">
            No brochures uploaded yet.
          </div>
        ) : (
          <div className="relative overflow-hidden rounded-2xl bg-white shadow-lg">
            <div className="aspect-[3/4] sm:aspect-[4/3] md:aspect-[786/490] bg-gray-50">
              <img
                src={brochures[activeIndex].imageSrc}
                alt={brochures[activeIndex].title}
                width={786}
                height={490}
                className="h-full w-full object-contain cursor-pointer"
                role="button"
                tabIndex={0}
                onClick={() => openImage(brochures[activeIndex].imageSrc)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    openImage(brochures[activeIndex].imageSrc);
                  }
                }}
              />
            </div>

            <div className="flex flex-col gap-3 border-t border-gray-100 p-4 md:flex-row md:items-center md:justify-between">
              <div>
                <p className="text-xs text-gray-500">
                  {activeIndex + 1} of {brochures.length}
                </p>
                <p className="text-base font-medium text-gray-900">
                  {brochures[activeIndex].title}
                </p>
              </div>
            </div>
          </div>
        )}
      </section>

      {isImageOpen && activeImageSrc && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-8 md:py-12"
          role="presentation"
          onClick={closeImage}
        >
          <div
            className="relative w-full max-w-5xl bg-white rounded-xl shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="absolute top-3 right-3 z-10 inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/70 text-white hover:bg-black/85 transition"
              aria-label="Close brochure"
              onClick={closeImage}
            >
              ×
            </button>
            <img
              src={activeImageSrc}
              alt="Brochure"
              width={786}
              height={490}
              className="h-full w-full object-contain max-h-[80vh]"
            />
          </div>
        </div>
      )}

      {/* Currency Exchange Section */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Live Exchange Rates Indicator */}
          <div className="flex items-center justify-center mb-6">
            <div className="flex items-center space-x-2 text-green-600">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-medium">Live Exchange Rates</span>
            </div>
          </div>

          {/* Main Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Currency <span className="text-orange-500">Exchange</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Get real-time exchange rates for 45+ currencies with transparent
              pricing and instant conversions
            </p>
          </div>

          {/* Currency Converter */}
          <div className="mb-16">
            <CurrencyConverter />
          </div>

          {/* Popular Exchange Rates */}
          <PopularExchangeRates />

          {/* Forex Service Cards */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Home Delivery Card */}
            <div className="rounded-2xl bg-gradient-to-br from-orange-500 to-orange-600 p-5 md:p-7 text-white shadow-xl flex flex-col">
              <div className="flex items-center gap-2 mb-3">
                <Truck className="w-5 h-5" />
                <span className="text-xs font-semibold uppercase tracking-wider opacity-90">Home Delivery</span>
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-2">
                Foreign Currency to Your Doorstep
              </h3>
              <p className="text-orange-100 text-sm mb-4">
                Skip the branch visit. Order online and get foreign currency delivered safely to your home — across Delhi NCR (Noida, Gurgaon & more).
              </p>
              <div className="flex flex-col gap-2 text-xs text-orange-100 mb-4">
                <span className="flex items-center gap-1.5"><ShieldCheck className="w-3.5 h-3.5 shrink-0" /> Secure &amp; Insured Delivery</span>
                <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 shrink-0" /> Fast Processing</span>
                <span className="flex items-center gap-1.5"><Truck className="w-3.5 h-3.5 shrink-0" /> Delhi NCR Delivery</span>
              </div>
              <div className="flex flex-col gap-1.5 text-xs text-orange-200 mb-6">
                <span className="bg-white/10 px-3 py-1.5 rounded-full">Orders up to ₹50,000 → ₹250 delivery charge</span>
                <span className="bg-white/10 px-3 py-1.5 rounded-full">Orders above ₹50,000 → ₹150 delivery charge</span>
              </div>
              <div className="mt-auto">
                <ForexHomeDeliveryModal
                  trigger={
                    <button className="w-full sm:w-auto bg-white text-orange-600 hover:bg-orange-50 font-bold px-6 py-3 rounded-xl shadow-md text-sm transition-all duration-200 flex items-center justify-center gap-2">
                      <Truck className="w-4 h-4" />
                      Order Home Delivery
                    </button>
                  }
                />
              </div>
            </div>

            {/* Branch Pickup Card */}
            <div className="rounded-2xl bg-gradient-to-br from-blue-600 to-indigo-700 p-5 md:p-7 text-white shadow-xl flex flex-col">
              <div className="flex items-center gap-2 mb-3">
                <Building2 className="w-5 h-5" />
                <span className="text-xs font-semibold uppercase tracking-wider opacity-90">Branch Pickup</span>
              </div>
              <h3 className="text-xl md:text-2xl font-bold mb-2">
                Pick Up from Our Branch
              </h3>
              <p className="text-blue-100 text-sm mb-4">
                Order online and collect your foreign currency at the most convenient Travel Wings location near you — no waiting, no hassle.
              </p>
              <div className="flex flex-col gap-2 mb-6 flex-1">
                {[
                  { name: "Sarita Vihar", addr: "105, 1st Floor, Pocket-B Market, Sarita Vihar, New Delhi – 110076" },
                  { name: "Barakhamba Road", addr: "2-P & 2-F, 2nd Floor, DCM Building, 16 Barakhamba Road, New Delhi – 110001" },
                  { name: "Vasant Kunj", addr: "C-28, Shop #5, Masoodpur, Vasant Kunj, New Delhi – 110070" },
                ].map((b) => (
                  <div key={b.name} className="flex items-start gap-2.5 bg-white/10 rounded-xl px-3 py-2.5">
                    <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-blue-200" />
                    <div>
                      <p className="font-semibold text-sm">{b.name}</p>
                      <p className="text-xs text-blue-200 mt-0.5 leading-snug">{b.addr}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-auto">
                <ForexHomeDeliveryModal
                  trigger={
                    <button className="w-full sm:w-auto bg-white text-blue-700 hover:bg-blue-50 font-bold px-6 py-3 rounded-xl shadow-md text-sm transition-all duration-200 flex items-center justify-center gap-2">
                      <Building2 className="w-4 h-4" />
                      Schedule Branch Pickup
                    </button>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <AboutSection />
      <ServicesSection />
      <AirlinePartners />
      <PackagesSection />
      <TeamSection />
      <ContactSection />
      <CareersSection />
      <Footer />
    </div>
  );
}
